import { useEffect } from "react";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import EbayListingsTable from "../../components/ebayListings/EbayListingsTable";
import useCategories from "../../data/useCategories";
import { ListedTableStats } from "../../components/ebayListings/listedTable/Stats/ListedTableStats";



export default function EbayListings() {
  const { setInfo } = usePageNameContext();
  const { categories } = useCategories();

  useEffect(() => {
    setInfo({
      name: "eBay Listings",
      desc: "View and manage parts that are listed on eBay",
    });
  }, []);

  if (categories.isLoading) return null;

  return (
    <div className="flex flex-col gap-4 mt-4">
      <ListedTableStats />
      <EbayListingsTable categories={categories.data?.data} />
    </div>
  );
}
